module.exports = __webpack_public_path__ + "static/media/  (176).8c34012d.jpg";